import moment from 'moment';
import { parseNewsItem } from 'cityads-v3/utils/newsUtils';
import {
  GET_CONVERSIONS_DATA,
  GET_CONVERSIONS_DATA_SUCCESS,
  GET_CONVERSIONS_DATA_FAIL,
  GET_TOP_WMS_DATA,
  GET_TOP_WMS_DATA_SUCCESS,
  GET_TOP_WMS_DATA_FAIL,
  GET_TOP_OFFERS_DATA,
  GET_TOP_OFFERS_DATA_SUCCESS,
  GET_TOP_OFFERS_DATA_FAIL,
  GET_NEW_AND_POP_OFFERS_DATA,
  GET_NEW_AND_POP_OFFERS_DATA_SUCCESS,
  GET_NEW_AND_POP_OFFERS_DATA_FAIL,
  GET_TOP_NEWS_DATA,
  GET_TOP_NEWS_DATA_SUCCESS,
  GET_TOP_NEWS_DATA_FAIL,
} from '../actions/home';

const initialState = {
  toolsCarouselItems: [
    {
      icon        : 'show_chart',
      moreLink    : 'statistics',
      articleClass: 'Statistics',
      translateKey: 'statistics',
      orderHome   : 50,
      orderAdv    : 50,
      orderWeb    : 40,
    },{
      icon        : 'data_usage',
      moreLink    : 'big_data',
      articleClass: 'BigData',
      translateKey: 'big_data',
      orderHome   : 60,
      orderAdv    : 60,
      orderWeb    : 110,
    },{
      icon        : 'exit_to_app',
      moreLink    : 'agent_cabinet',
      articleClass: 'AgentCabinet',
      translateKey: 'agent_cabinet',
      orderHome   : 70,
      orderAdv    : 0,
      orderWeb    : 50,
    },{
      icon        : 'attach_money',
      moreLink    : 'firano',
      articleClass: 'FiranoApi',
      translateKey: 'firano_api',
      orderHome   : 40,
      orderAdv    : 40,
      orderWeb    : 30,
    },{
      icon        : 'shopping_cart',
      moreLink    : 'product_feed',
      articleClass: 'ProductFeed',
      translateKey: 'product_feed',
      orderHome   : 80,
      orderAdv    : 70,
      orderWeb    : 60,
    },{
      icon        : 'loyalty',
      moreLink    : 'coupon_feed',
      articleClass: 'CouponFeed',
      translateKey: 'coupon_feed',
      orderHome   : 20,
      orderAdv    : 20,
      orderWeb    : 20,
    },{
      icon        : 'settings_applications',
      moreLink    : 'api',
      articleClass: 'API',
      translateKey: 'api',
      orderHome   : 100,
      orderAdv    : 0,
      orderWeb    : 80,
    },{
      icon        : 'refresh',
      moreLink    : 'conversion_postback',
      articleClass: 'ConversionPostback',
      translateKey: 'conversion_postback',
      orderHome   : 110,
      orderAdv    : 0,
      orderWeb    : 90,
    },{
      icon        : 'widgets',
      moreLink    : 'widgets',
      articleClass: 'Widgets',
      translateKey: 'widgets',
      orderHome   : 10,
      orderAdv    : 10,
      orderWeb    : 10,
    },{
      icon        : 'find_in_page',
      moreLink    : 'lost_orders',
      articleClass: 'LostOrders',
      translateKey: 'lost_orders',
      orderHome   : 5,
      orderAdv    : 0,
      orderWeb    : 5,
      flag        : 'New!'
    },
  ],

  tabItems: [
    {
      id         : 1,
      category_id: ['1980', '1982', '10001', '10002', '10004', '10005', '10006', '10187', '1983', '10007', '10008', '10009', '10010', '10011', '10012'],
      top        : '80+',
      translateId: 0,
      description: '80+'
    }, {
      id         : 2,
      category_id: ['10111', '10120', '10121', '10122'],
      top        : '35+',
      translateId: 1,
      description: '35+'
    }, {
      id         : 3,
      category_id: ["10016", "10154", "10155", "1974", "10156", "1975", "10164", "10135", "10165", "10147", "10167", "10149", "1977", "1978", "1979", "10018", "10019", "10170", "10174", "10175"],
      top        : '350+',
      translateId: 2,
      description: '350+'
    }, {
      id         : 4,
      category_id: ["10023", "2", "307", "376", "910", "1064", "1133", "1177", "1291", "1479", "1505", "1516", "1554", "1590", "1722", "1785", "1906", "10024", "10110", "10138", "10139", "10141", "10143", "10171", "10182", "10183"],
      top        : '900+',
      translateId: 3,
      description: '900+'
    }, {
      id         : 5,
      category_id: ["10021", "908", "2003", "10022", "10152", "10176", "10177"],
      top        : '60+',
      translateId: 4,
      description: '60+'
    }, {
      id                    : 6,
      direction_and_platform: ['4-0'],
      top                   : '15+',
      translateId           : 5,
      description           : '15+'
    },
  ],

  recentConversionsStat: null,
  isLoadingConversionsData: false,
  isConversionsDataLoaded: false,

  topWMs: null,
  isLoadingTopWMsData: false,
  isTopWMsDataLoaded: false,

  topOffers: null,
  isLoadingTopOffersData: false,
  isTopOffersDataLoaded: false,

  mainOffers: {
    newest: null,
    mostPopular: null,
  },
  isLoadingMainOffersData: false,
  isMainOffersDataLoaded: false,

  mainNews: null,
  isLoadingMainNewsData: false,
  isMainNewsDataLoaded: false,
};

export default function home(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CONVERSIONS_DATA:
      return {
        ...state,
        isLoadingConversionsData: true,
        isConversionsDataLoaded: false,
      };

    case GET_CONVERSIONS_DATA_SUCCESS:
      const data = action.response.data;

      const recentConversionsStat = data ? data.map((statDay) => ({
        x: moment(statDay.date, 'D.M.Y').valueOf(),
        y: parseInt(statDay.value, 10)
      })) : [];

      return {
        ...state,
        recentConversionsStat,
        isLoadingConversionsData: false,
        isConversionsDataLoaded: !!data,
      };

    case GET_CONVERSIONS_DATA_FAIL:
      return {
        ...state,
        isLoadingConversionsData: false,
        isConversionsDataLoaded: false,
      };

    case GET_TOP_WMS_DATA:
      return {
        ...state,
        isLoadingTopWMsData: true,
        isTopWMsDataLoaded: false,
      };

    case GET_TOP_WMS_DATA_SUCCESS:
      const topWMs = action.response.data;

      return {
        ...state,
        topWMs: Array.isArray(topWMs) ? { values: topWMs, currency: null } : topWMs,
        isLoadingTopWMsData: false,
        isTopWMsDataLoaded: !!topWMs,
      };

    case GET_TOP_WMS_DATA_FAIL:
      return {
        ...state,
        isLoadingTopWMsData: false,
        isTopWMsDataLoaded: false,
      };

    case GET_TOP_OFFERS_DATA:
      return {
        ...state,
        isLoadingTopOffersData: true,
        isTopOffersDataLoaded: false,
      };

    case GET_TOP_OFFERS_DATA_SUCCESS:
      const topOffers = action.response.data;

      return {
        ...state,
        topOffers,
        isLoadingTopOffersData: false,
        isTopOffersDataLoaded: !!topOffers,
      };

    case GET_TOP_OFFERS_DATA_FAIL:
      return {
        ...state,
        isLoadingTopOffersData: false,
        isTopOffersDataLoaded: false,
      };

    case GET_NEW_AND_POP_OFFERS_DATA:
      return {
        ...state,
        isLoadingMainOffersData: true,
        isMainOffersDataLoaded: false,
      };

    case GET_NEW_AND_POP_OFFERS_DATA_SUCCESS:
      const { newest, most_popular } = action.response.data;

      return {
        ...state,
        mainOffers: {
          newest: (newest && (newest.offer || (newest.values && !newest.values.hasOwnProperty('length')))) ? {
            offer : newest.offer || {},
            values: (newest.values && !newest.values.hasOwnProperty('length')) ? newest.values : {}
          } : null,
          mostPopular: (most_popular && (most_popular.offer || (most_popular.values && !most_popular.values.hasOwnProperty('length')))) ? {
            offer : most_popular.offer || {},
            values: (most_popular.values && !most_popular.values.hasOwnProperty('length')) ? most_popular.values : {}
          } : null,
        },
        isLoadingMainOffersData: false,
        isMainOffersDataLoaded: !!newest || !most_popular,
      };

    case GET_NEW_AND_POP_OFFERS_DATA_FAIL:
      return {
        ...state,
        isLoadingMainOffersData: false,
        isMainOffersDataLoaded: false,
      };

    case GET_TOP_NEWS_DATA:
      return {
        ...state,
        isLoadingMainNewsData: true,
        isMainNewsDataLoaded: false,
      };

    case GET_TOP_NEWS_DATA_SUCCESS:
      const { news } = action.response;
      const mainNews = news && !Array.isArray(news) ? parseNewsItem(news): undefined;

      return {
        ...state,
        mainNews,
        isLoadingMainNewsData: false,
        isMainNewsDataLoaded: !!news,
      };

    case GET_TOP_NEWS_DATA_FAIL:
      return {
        ...state,
        isLoadingMainNewsData: false,
        isMainNewsDataLoaded: false,
      };

    default:
      return state;
  }
}
